import type { ID } from "@/interfaces";

export interface ILoginMetaData {
  userName: string;
  password: string;
}

export interface IForgetPasswordMeteData {
  userName: string;
  otp: string;
  reqId: ID;
}

export interface IAuthStore {
  resetState: () => void;
  step: IAuthStepEnum;
  setStep: (state: IAuthStepEnum) => void;
  forgetPasswordMeteData: IForgetPasswordMeteData;
  setForgetPasswordMeteData: (state: IForgetPasswordMeteData) => void;
}

export enum IAuthStepEnum {
  LOGIN = "login",
  RESET_PASSWORD = "reset-password",
  SIGNUP = "signUp",
  // eslint-disable-next-line @typescript-eslint/no-mixed-enums
  CHECK_RESET_PASSWORD_VERIFICATION_EMAIL = 0,
  CHECK_RESET_PASSWORD_VERIFICATION_PHONE,
  CHECK_SIGN_UP_VERIFICATION_PHONE,
  SET_NEW_PASSWORD,
  COMPLETE_SIGNUP_INFO,
}
